import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllReportsData } from "../../../redux/service/action";
import DatesSelect from "./DatesSelect";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import upload from "../../assets/./images/upload.svg";
import PurchaseReportExport from "./PurchaseReportExport";

const PurchaseReport = ({ selectedOptions, testingAccountFilter = "hide" }) => {
  const [params, setParams] = useState({
    type: "purchase_report",
    start_date: "", // Initially empty
    end_date: "",
    user_id: selectedOptions,
    testing_account_filter: testingAccountFilter,
  });

  const dispatch = useDispatch();
  const purchaseReport = useSelector(
    (state) => state?.reusableSlice?.getReportsData?.purchase_report
  );

  const formattedData =
    purchaseReport && Array.isArray(purchaseReport)
      ? purchaseReport.map((item) => ({
          name: item?.month_name,
          total: item?.total,
        }))
      : [];

  useEffect(() => {
    dispatch(getAllReportsData(params));
  }, [dispatch, params]);

  useEffect(() => {
    setParams((prevParams) => ({
      ...prevParams,
      user_id: selectedOptions,
      testing_account_filter: testingAccountFilter,
    }));
  }, [selectedOptions, testingAccountFilter]);

  return (
    <div
      className="background-grpah"
      style={{
        width: "100%",
        padding: 20,
        background: "#F1F1F8",
        borderRadius: 10,
      }}
    >
      <div
        className="d-flex align-items-center justify-content-between w-100 pb-3"
        style={{ columnGap: "20px" }}
      >
        <div
          className="d-flex align-items-center "
          style={{ columnGap: "30px" }}
        >
          <h4 className="w-100">Purchase Report</h4>
          <DatesSelect setParams={setParams} />
        </div>

        <PurchaseReportExport params={params}></PurchaseReportExport>
      </div>
      <div
        style={{
          width: "100%",
          padding: 20,
          borderRadius: 10,
          height: "380px",
        }}
      >
        <ResponsiveContainer>
          <BarChart
            width={500}
            height={200}
            barSize={40}
            data={formattedData}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <XAxis dataKey="name" />
            <YAxis />
            <CartesianGrid strokeDasharray="3 3" />
            <Tooltip />
            <Legend />
            <Bar
              dataKey="total"
              fill="#A0E7A0"
              barSize={30}
              name="Total Purchase"
              radius={[10, 10, 10, 10]}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default PurchaseReport;
